import { NgModule } from '@angular/core';
import { ParticleEffectButtonDirective } from './angular-particle-effect-button.directive';

@NgModule({
  declarations: [ParticleEffectButtonDirective],
  exports: [ParticleEffectButtonDirective],
})
export class ParticleEffectButtonModule {
}

